import { type SessionChunk } from '../../types';

export const getChunkInfo = (chunk: SessionChunk) => {
  const { id, index, sessionId, recordingId, duration } = chunk;
  return { id, index, sessionId, recordingId, duration };
};
